import React, { useEffect } from "react";
import { useToast } from "native-base";
import ToastAlert from "../nativeBase-ui/ToastAlert";
import * as AppActions from "../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
const DURATION: number = 3000;
interface Props {
  AppReducer: any;
  clearMessageToast: () => void;
}
const MessageToast = (props: Props) => {
  const AppReducer = useSelector((state: any) => state.AppReducer);
  const dispatch = useDispatch();
  var messageToast = AppReducer?.messageToast;
  const toast = useToast();
  useEffect(() => {
    // toastHandler();
    if (Object.keys(messageToast).length > 0) {
      toastHandler();
      dispatch(AppActions.clearMessageToast());
    }
  }, [messageToast]);
  // === example ===
  // var toastDetail = {
  //   title,
  //   variant: "top-accent",
  //   status,
  //   description,
  //   duration,   If set to null, toast will never dismiss.
  //   isClosable,
  //   countDown,
  //   scenarioRunUId,
  // };
  const closeAll = () => {
    toast.closeAll();
  };
  const ToastDetailsGenerator: any = Object.keys(messageToast).length > 0 && {
    ...messageToast,
  };
  const toastHandler = () => {
    var executed = false;
    return (function () {
      if (!executed) {
        executed = true;
        if (
          ToastDetailsGenerator &&
          Object.keys(ToastDetailsGenerator).length > 0
        ) {
          toast.show({
            duration:
              messageToast?.duration === null
                ? null
                : messageToast?.duration || DURATION,
            // placement: "top",
            // description: ToastDetailsGenerator.title,
            render: () => {
              return (
                <ToastAlert
                  {...ToastDetailsGenerator}
                  variant="top-accent"
                  closeToastHandler={() => closeAll()}
                />
              );
            },
          });
        }
      }
    })();
  };

  return null;
};
export default MessageToast;
